import React from 'react'

const PurchaseHistory = () => {
  return (
    <div className=' w-screen h-screen flex items-center justify-center'>
      Page Under Construction
    </div>
  )
}

export default PurchaseHistory
